module.exports = __webpack_public_path__ + "img/组 4.0136c740.webp";